export default __webpack_public_path__ + "assets/images/7a61a0bd5e35d570b593e811d52dac4c.png";